import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {take} from 'rxjs/operators';
import {AppConfigService} from '../../../../Services/app-config.service';
import {BsToastService} from '../../../../Services/bs-toast-service';

@Component({
  standalone: false,
  selector: 'app-bank-import-ignore-rules',
  templateUrl: './bank-import-ignore-rules.component.html'
})
export class BankImportIgnoreRulesComponent implements OnInit, OnChanges {
  @Input() bankId: string = '';
  @Input() companyId: string = '';

  vm: any = {
    rules: [],
    loading: false,
    saving: false,
    deleteConfirmId: null,
    editId: null,
    editRule: null,
    newRule: {
      field: 'description',
      operator_type: 'contains',
      value: '',
      note: '',
      case_sensitive: false
    }
  };

  private get apiBase(): string {
    return this.appConfig.apiBaseUrl;
  }

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private notification: BsToastService
  ) {
  }

  ngOnInit() {
    if (this.bankId) {
      this.loadRules();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['bankId'] || changes['companyId']) && this.bankId) {
      this.loadRules();
    }
  }

  loadRules() {
    if (!this.bankId) {
      return;
    }
    this.vm.loading = true;
    let url = this.apiBase + 'bank-ignore-rules?bank_id=' + this.bankId;
    if (this.companyId) {
      url += '&company_id=' + this.companyId;
    }
    console.log('[BankImportIgnoreRules][loadRules] url:', url);
    this.http.get<any>(url).pipe(take(1)).subscribe({
      next: (result) => {
        console.log('[BankImportIgnoreRules][loadRules] result:', result);
        this.vm.rules = result.Data || result.data || result || [];
        this.vm.loading = false;
      },
      error: (err) => {
        console.log('[BankImportIgnoreRules][loadRules] error:', err);
        this.vm.loading = false;
      }
    });
  }

  addRule() {
    if (!this.vm.newRule.value.trim()) {
      this.notification.showErrorToast('Value is required.', 'Validation');
      return;
    }
    this.vm.saving = true;
    const payload = {
      bank_id: this.bankId,
      company_id: this.companyId,
      field: this.vm.newRule.field,
      operator_type: this.vm.newRule.operator_type,
      value: this.vm.newRule.value.trim(),
      note: this.vm.newRule.note.trim(),
      case_sensitive: this.vm.newRule.case_sensitive
    };
    console.log('[BankImportIgnoreRules][addRule] url:', this.apiBase + 'bank-ignore-rules', 'payload:', payload);
    this.http.post<any>(this.apiBase + 'bank-ignore-rules', payload).pipe(take(1)).subscribe({
      next: () => {
        this.vm.saving = false;
        this.vm.newRule = {field: 'description', operator_type: 'contains', value: '', note: '', case_sensitive: false};
        this.loadRules();
      },
      error: () => {
        this.vm.saving = false;
        this.notification.showErrorToast('Failed to save rule.', 'Error');
      }
    });
  }

  startEdit(rule: any) {
    this.vm.editId = rule.id;
    this.vm.editRule = {...rule};
    this.vm.deleteConfirmId = null;
  }

  cancelEdit() {
    this.vm.editId = null;
    this.vm.editRule = null;
  }

  saveEdit() {
    if (!this.vm.editRule.value?.trim()) {
      this.notification.showErrorToast('Value is required.', 'Validation');
      return;
    }
    this.vm.saving = true;
    const payload = {
      bank_id: this.bankId,
      company_id: this.companyId,
      field: this.vm.editRule.field,
      operator_type: this.vm.editRule.operator_type,
      value: this.vm.editRule.value.trim(),
      note: this.vm.editRule.note?.trim() || '',
      case_sensitive: this.vm.editRule.case_sensitive
    };
    this.http.put<any>(this.apiBase + 'bank-ignore-rules/' + this.vm.editId, payload).pipe(take(1)).subscribe({
      next: () => {
        this.vm.saving = false;
        this.vm.editId = null;
        this.vm.editRule = null;
        this.loadRules();
      },
      error: () => {
        this.vm.saving = false;
        this.notification.showErrorToast('Failed to save rule.', 'Error');
      }
    });
  }

  confirmDelete(id: string) {
    this.vm.deleteConfirmId = id;
  }

  cancelDelete() {
    this.vm.deleteConfirmId = null;
  }

  deleteRule(id: string) {
    this.http.delete(this.apiBase + 'bank-ignore-rules/' + id).pipe(take(1)).subscribe({
      next: () => {
        this.vm.deleteConfirmId = null;
        this.loadRules();
      },
      error: () => {
        this.notification.showErrorToast('Failed to delete rule.', 'Error');
      }
    });
  }
}
